import React from 'react';

import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { HOME_INSURANCE_VERTICAL } from 'types/marketplaceTiles.constants';
import { RENTERS_INSURANCE_OCF } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel } from 'hook/helper.hook';

import PageLoadingMask from 'components/masks/PageLoadingMask';
import RentersInsuranceMarketplaceModuleView from './RentersInsuranceMarketplaceModuleView';

const RentersInsuranceOcfModuleController = props => {
  const homeInsuranceHook = props.homeInsuranceHook;
  const hiConfig = props.config?.marketplace?.hi;
  const checkBoxList = hiConfig?.checkBoxList;
  const insurers = hiConfig?.insurers;
  const maritalStatus = hiConfig?.maritalStatus;
  const propertyTypes = hiConfig?.propertyTypes;

  const onSelectMultiQuestionOptions = func => {
    homeInsuranceHook.setMultiChoiceAnswers(
      func(homeInsuranceHook?.multiChoiceAnswers),
    );
  };

  const datatestid = 'HomeInsurance';
  const loading = props.globalLoadingFlag;
  const atr = getViewModuleTrackingAttributes({
    pagePosition: RENTERS_INSURANCE_OCF,
    modulePosition: props.modulePosition,
    vertical: HOME_INSURANCE_VERTICAL,
  });

  const seenPixel = useSeenModulePixel(atr);

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <>
        {seenPixel}
        <RentersInsuranceMarketplaceModuleView
          {...props}
          {...homeInsuranceHook}
          datatestid={datatestid}
          checkBoxList={checkBoxList}
          propertyTypes={propertyTypes}
          insurers={insurers}
          maritalStatus={maritalStatus}
          onSelectMultiQuestionOptions={onSelectMultiQuestionOptions}
          pagePosition={RENTERS_INSURANCE_OCF}
        />
      </>
    );
  }
};

export default RentersInsuranceOcfModuleController;
